import { useQuery } from '@tanstack/react-query';

import { intercomQueries } from './queries';
import { IntercomJWTParams } from './types';

export const useGetIntercomJWT = (params: IntercomJWTParams | undefined) => {
  const {
    data: intercomJWT,
    isPending,
    isError,
  } = useQuery(intercomQueries.jwt(params));

  return { intercomJWT, isPending, isError };
};
